import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useInView } from 'common/hooks';
import { TGAPromoView } from 'utils/analytics/types';
import { GAPromoView } from 'utils/analytics/analytics-events';
import { selectPopularCategories } from '../../selectors';
import { getPath } from '../../../../../selectors';

export const usePopularCategoriesSliderAnalytics = () => {
	const { ref, inView } = useInView();
	const path = useSelector(getPath);
	const categoriesData = useSelector(selectPopularCategories);
	const [visibleSlidesIndexes, setVisibleSlidesIndexes] = useState([]);
	const [isCategoryAnalyticsSent, setIsCategoryAnalyticsSent] = useState(
		new Array(categoriesData.length).fill(false)
	);
	// isCategoryAnalyticsSent массив с количеством элементов равный количеству услуг [true, true, true, true, true, true, true, false]
	// true - услуга уже показана и аналитика по ней отправлена false - услуга не была показана

	const blockPlacement = path.includes('ustanovka-i-remont')
		? 'servicePage_top'
		: 'servicePage_bottom';

	const updateIsCategoryAnalyticsSent = visibleSlidesIndexesArr => {
		const isServiceAnalyticsSentTemp = [...isCategoryAnalyticsSent];
		visibleSlidesIndexesArr.forEach(slideIndex => {
			if (!isServiceAnalyticsSentTemp[slideIndex]) {
				isServiceAnalyticsSentTemp[slideIndex] = true;
			}
		});
		setIsCategoryAnalyticsSent([...isServiceAnalyticsSentTemp]);
	};

	const handleChangeSlide = (
		realIndex: number,
		previousIndex: number,
		visibleSlidesIndexesArr: number[]
	) => {
		setVisibleSlidesIndexes([...visibleSlidesIndexesArr]);
		let slideIndex;
		if (realIndex < previousIndex) {
			// отправить аналитику с первым видимым элементом если прокрутили назад
			[slideIndex] = visibleSlidesIndexesArr;
		} else {
			// отправить аналитику с последним видимым элементом visibleSlidesIndexes если прокрутили вперед
			slideIndex = visibleSlidesIndexesArr[visibleSlidesIndexesArr.length - 1];
		}

		const promotions = isCategoryAnalyticsSent[slideIndex]
			? []
			: [
					{
						name: blockPlacement,
						creative: categoriesData[slideIndex].categoryName,
						position: slideIndex + 1,
					},
			  ];
		if (promotions.length !== 0) {
			const promoViewData: TGAPromoView = {
				elementBlock: 'servicePage / popular',
				promotions,
			};
			GAPromoView(promoViewData);
		}
		updateIsCategoryAnalyticsSent([...visibleSlidesIndexesArr]);
	};

	const handleInitSwiper = (visibleSlidesIndexesArr: number[]) => {
		setVisibleSlidesIndexes([...visibleSlidesIndexesArr]);
	};

	useEffect(() => {
		if (inView) {
			const promotions = visibleSlidesIndexes
				.filter(visibleSlideIndex => isCategoryAnalyticsSent[visibleSlideIndex] === false) // фильтруем, индексы видимых карточек, чтобы проверить отправлялась ли уже по ним аналитика или нет
				.map(visibleSlideIndex => ({
					// проходимся по отфильтрованным индексам карточек и создаем массив promotions который отправится в аналитике
					name: blockPlacement,
					creative: categoriesData[visibleSlideIndex].categoryName,
					position: visibleSlideIndex + 1,
				}));

			if (promotions.length !== 0) {
				const promoViewData: TGAPromoView = {
					elementBlock: 'servicePage / popular',
					promotions,
				};
				GAPromoView(promoViewData);
			}

			updateIsCategoryAnalyticsSent([...visibleSlidesIndexes]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView, visibleSlidesIndexes]);

	return {
		handleInitSwiper,
		handleChangeSlide,
		categoriesData,
		ref,
	};
};
